<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-3" xml:lang="en-GB"><img alt="" class="_idGenObjectAttribute-2" src="image/HueTitle1.jpg"/> </p>
<p class="BT-1st ParaOverride-3"><span class="CharOverride-3">A Turning Point of <br/>the American War in Vietnam</span></p>
<h2 class="AU_Author_names ParaOverride-4" xml:lang="en-GB"><span class="CharOverride-4">Mark <br/>Bowden</span></h2>
<p class="BT-1st ParaOverride-5"><img alt="" class="_idGenObjectAttribute-3" src="image/V-1.png"/></p>
<p class="BT-1st ParaOverride-3">Grove Press</p>
<p class="BT-1st ParaOverride-3"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45572.vue?11970df8